export default "__VITE_ASSET__mhvlTEzL__"